/*
 * Copyright (c) 2018 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained here in is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */
import { Button, Grid, WithStyles, withStyles } from "@material-ui/core";
import * as React from "react";

import { Form } from "../../types/Form";
import { UiFormBuilder } from "../../utils/UiFormBuilder";
import { UpdateRequestBuilder } from "../../utils/UpdateRequestBuilder";
import InputPassword from "../InputPassword/InputPassword";
import { styles } from "./FormPasswordProfil.style";
import { theme } from "../../theme/theme";

interface FormPasswordProfilProps extends WithStyles<typeof styles> {
    onSubmit: (currentPassword?: string, newPassword?: string) => void;
    onCancel?();
}

type FormPasswordProfilState = {
    form: Form<FormPasswordProfilData>;
};

interface FormPasswordProfilData {
    currentPassword?: string;
    newPassword?: string;
    newPasswordConfirmation?: string;
}

class FormPasswordProfil extends React.Component<FormPasswordProfilProps, FormPasswordProfilState> {
    protected formBuilder: any = null;
    protected form: any = null;

    constructor(props: FormPasswordProfilProps) {
        super(props);
        this.formBuilder = new UiFormBuilder<FormPasswordProfilData>()
            .addField("currentPassword", {
                props: {
                    label: "Mot de passe Actuel",
                    placeholder: "Mot de passe Actuel",
                    required: true,
                },
            })
            .addField("newPassword", {
                props: {
                    label: "Nouveau mot de passe",
                    placeholder: "Nouveau mot de passe",
                    required: true,
                },
            })
            .addField("newPasswordConfirmation", {
                props: {
                    label: "Confirmation de mot de passe",
                    placeholder: "Confirmation de mot de passe",
                    required: true,
                    onInput: this.onCheck.bind(this),
                },
            })
            .onChange(this.onChange.bind(this));

        this.state = {
            form: {
                fields: {},
                errors: [],
                values: {},
            },
        };
    }

    public onChange(fieldName: string, value: any) {
        const builder = new UpdateRequestBuilder();
        builder.set(`values.${fieldName}`, value);
        let form = builder.exec(this.state.form);
        this.setState({ form: form });
    }

    public onSubmit(e) {
        e.preventDefault();
        const { currentPassword, newPassword } = this.state.form.values;
        // TODO @BM verify password matches confirmation
        if (this.form.reportValidity() && this.props.onSubmit) {
            this.props.onSubmit(currentPassword, newPassword);
        }
    }

    public onCheck(value: string, reporter: any) {
        if (value !== this.state.form.values.newPassword) {
            reporter.setCustomValidity("Les mots de passe doivent être identiques");
        } else {
            reporter.setCustomValidity("");
        }
    }

    public render() {
        if (!this.state) {
            return null;
        }

        const uiForm = this.formBuilder.build(this.state.form);
        const { classes } = this.props;

        return (
            <form ref={(ref) => (this.form = ref)} onSubmit={this.onSubmit.bind(this)}>
                <Grid container={true} spacing={16} wrap={"wrap"}>
                    <Grid item={true} sm={12}>
                        <InputPassword {...uiForm.fields.currentPassword} />
                    </Grid>
                    <Grid item={true} sm={12}>
                        <InputPassword {...uiForm.fields.newPassword} />
                    </Grid>
                    <Grid item={true} sm={12}>
                        <InputPassword {...uiForm.fields.newPasswordConfirmation} />
                    </Grid>
                    <Grid container={true} item={true} sm={12} justify="center" className={classes.submit}>
                        <Button type="submit" color="primary" variant="contained">
                            Valider
                        </Button>
                        <Button
                            style={{ marginLeft: theme.spacing.unit }}
                            onClick={this.props.onCancel}
                            variant="outlined"
                            type="submit"
                            color="primary"
                        >
                            Annuler
                        </Button>
                    </Grid>
                </Grid>
            </form>
        );
    }
}

export default withStyles(styles)(FormPasswordProfil);



// WEBPACK FOOTER //
// ./src/components/FormPasswordProfil/FormPasswordProfil.tsx